<template>
  <div class="background-video-slider carousel slide" data-ride="carousel" id="backgroundVideoSlider" role="region" :data-brand="getBrand">
    <div class="carousel-inner" role="listbox">
      <div class="item sokal-component-slide slide-0 slide-id-6932 video-slide active slow-load slide-processed video-can-play">
        <div class="component-slide-content">
          <video v-if="images.videoLink.length > 0" class="slide-background-video" loop="true" muted="true" playsinline="true" preload="metadata" autoplay="true">
            <source :src="images.videoLink" type="video/mp4">
          </video>
          <div class="slide-background-overlay"></div>
          <div class="slide-content-layer sokal-content-fade-in">
            <div class="slide-text-content">
              <div class="offer-text-template-4">
                <h2 class="sokal-component-heading">Adventure Awaits</h2>
                <p class="sokal-component-copy">Explore our lineup of 2025 models or shop used and find your next vehicle today.</p>
              </div>
            </div>
            <div class="slide-buttons" data-first-btn-present="true">
              <a class="sokal-btn sokal-btn-secondary dark-theme" href="#">Shop Used</a>
              <a class="additional-btn sokal-btn sokal-btn-primary dark-theme" href="#">Shop New</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item sokal-component-slide slide-1 slide-id-6931 bg-image-slide">
        <div class="component-slide-content">
          <div class="slide-background">
            <img class="slide-background-image" :src="images.lifestyleImages.suvImage" role="presentation">
          </div>
          <div class="slide-background-overlay"></div>
          <div class="slide-content-layer sokal-content-fade-in">
            <div class="slide-text-content">
              <div class="offer-text-template-3">
                <h3 class="sokal-component-subheading">Explore</h3>
                <h2 class="sokal-component-heading">Shop New {{ getBrand === 'Default' ? '2024' : getBrand }} SUVs</h2>
              </div>
            </div>
            <div class="slide-buttons" data-first-btn-present="true">
              <a class="sokal-btn sokal-btn-secondary dark-theme" href="#">View Inventory</a>
            </div>
          </div>
        </div>
      </div>
      <div class="item sokal-component-slide slide-2 slide-id-6936 bg-image-slide">
        <div class="component-slide-content">
          <div class="slide-background">
            <img class="slide-background-image" :src="images.lifestyleImages.sedanImage" role="presentation">
          </div>
          <div class="slide-background-overlay"></div>
          <div class="slide-content-layer sokal-content-fade-in">
            <div class="slide-text-content">
              <div class="offer-text-template-3">
                <h3 class="sokal-component-subheading">Explore</h3>
                <h2 class="sokal-component-heading">Shop New {{ getBrand === 'Default' ? '2024' : getBrand }} Sedans</h2>
              </div>
            </div>
            <div class="slide-buttons" data-first-btn-present="true">
              <a class="sokal-btn sokal-btn-secondary dark-theme" href="#">View Inventory</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ol class="carousel-indicators">
      <li class="sokal-slide-indicator active" data-slide-to="0" data-target="#backgroundVideoSlider"></li>
      <li class="sokal-slide-indicator" data-slide-to="1" data-target="#backgroundVideoSlider"></li>
      <li class="sokal-slide-indicator" data-slide-to="2" data-target="#backgroundVideoSlider"></li>
    </ol>
    <button class="navigate-slides prev-slide" data-slide="prev" data-target="#backgroundVideoSlider" role="button">
      <svg aria-hidden="true" class="arrow-left-no-border" height="100%" preserveAspectRatio="xMidYMid meet" role="img" viewBox="0 0 256 256" width="100%">
        <path clip-rule="evenodd" d="M182.82 131.62C183.781 130.66 184.32 129.358 184.32 128C184.32 126.642 183.781 125.34 182.82 124.38C181.86 123.419 180.558 122.88 179.2 122.88H89.1648L121.382 90.6624C122.343 89.7016 122.883 88.3986 122.883 87.04C122.883 85.6813 122.343 84.3783 121.382 83.4176C120.422 82.4568 119.119 81.9171 117.76 81.9171C116.401 81.9171 115.098 82.4568 114.138 83.4176L73.1776 124.378C72.7016 124.853 72.324 125.418 72.0663 126.039C71.8086 126.661 71.676 127.327 71.676 128C71.676 128.673 71.8086 129.339 72.0663 129.961C72.324 130.582 72.7016 131.147 73.1776 131.622L114.138 172.582C115.098 173.543 116.401 174.083 117.76 174.083C119.119 174.083 120.422 173.543 121.382 172.582C122.343 171.622 122.883 170.319 122.883 168.96C122.883 167.601 122.343 166.298 121.382 165.338L89.1648 133.12H179.2C180.558 133.12 181.86 132.581 182.82 131.62Z" fill="currentColor" fill-rule="evenodd"></path>
      </svg>
      <span class="sr-only">Previous</span>
    </button>
    <button class="navigate-slides next-slide" data-slide="next" data-target="#backgroundVideoSlider" role="button">
      <svg aria-hidden="true" class="arrow-right-no-border" height="100%" preserveAspectRatio="xMidYMid meet" role="img" viewBox="0 0 256 256" width="100%">
        <path clip-rule="evenodd" d="M183.934 126.039C183.676 125.418 183.298 124.853 182.822 124.378L141.862 83.4176C140.902 82.4568 139.599 81.9171 138.24 81.9171C136.881 81.9171 135.578 82.4568 134.618 83.4176C133.657 84.3783 133.117 85.6813 133.117 87.04C133.117 88.3986 133.657 89.7016 134.618 90.6624L166.835 122.88H76.8C75.4421 122.88 74.1398 123.419 73.1797 124.38C72.2195 125.34 71.6801 126.642 71.6801 128C71.6801 129.358 72.2195 130.66 73.1797 131.62C74.1398 132.581 75.4421 133.12 76.8 133.12H166.835L134.618 165.338C133.657 166.298 133.117 167.601 133.117 168.96C133.117 170.319 133.657 171.622 134.618 172.582C135.578 173.543 136.881 174.083 138.24 174.083C139.599 174.083 140.902 173.543 141.862 172.582L182.822 131.622C183.298 131.147 183.676 130.582 183.934 129.961C184.191 129.339 184.324 128.673 184.324 128C184.324 127.327 184.191 126.661 183.934 126.039Z" fill="currentColor" fill-rule="evenodd"></path>
      </svg>
      <span class="sr-only">Next</span>
    </button>
  </div>
</template>

<script>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    getBrand () {
      if (this.brand.toLowerCase() === 'none') {
        return 'Default';
      } else {
        return this.brand.substr(0,1).toUpperCase() + this.brand.substr(1);
      }
    }
  }, 

  mounted () {
    let firstItem = $('.background-video-slider .video-slide');
    firstItem.animate({background: 'linear-gradient(to top, #111111 1%, transparent 40%);'}, "1000");
    setTimeout(function(){
      firstItem.removeClass('slow-load');
    }, 1000)
    
  }, 

  methods: {
    
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .background-video-slider {
    --carousel-controls-color: #ffffff;
    --slide-overlay-background-color: #111111;
  }

  #preview:has(#backgroundVideoSlider) {
    margin-left: -9px;
    margin-right: -9px;
  }

  .background-video-slider {
    font-size: 16px;
  }
  .background-video-slider .item {
    width: 100%;
  }
  .background-video-slider button.navigate-slides {
    position: absolute;
    bottom: 10px;
    left: 50%;
  }
  .background-video-slider button.prev-slide {
    left: calc(50% - 15px);
    transform: translateX(calc(-50% - 15px));
  }
  .background-video-slider button.next-slide {
    left: calc(50% + 15px);
    transform: translateX(calc(-50% + 15px));
  }
  .background-video-slider button.navigate-slides {
    width: 45px;
    padding: 0;
    background-color: transparent;
    border: none;
    color: #ffffff;
    color: var(--carousel-controls-color, #ffffff);
  }
  .background-video-slider button.navigate-slides svg {
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .background-video-slider button.navigate-slides:hover svg, 
  .background-video-slider button.navigate-slides:focus svg {
    transform: scale(0.95);
  }
  .background-video-slider .carousel-indicators {
    z-index: auto;
  }
  .background-video-slider .carousel-indicators li, 
  .background-video-slider .carousel-indicators .active {
    margin: 0 5px;
  }
  .background-video-slider .carousel-indicators li {
    width: 0px;
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .background-video-slider .carousel-indicators .active {
    width: 0px;
    height: 20px;
  }
  .background-video-slider .component-slide-content {
    position: relative;
    min-height: 400px;
    height: 79.5vh;
    overflow: hidden;
  }
  .background-video-slider .component-slide-content > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .background-video-slider .slide-background {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .background-video-slider[data-brand="Infiniti"] .slide-1 .slide-background .slide-background-image {
    object-position: bottom;
  }
  .background-video-slider .slide-background-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .background-video-slider .slide-background-overlay, 
  .background-video-slider .slide-content-layer {
    position: absolute;
  }
  .background-video-slider .slide-background-overlay {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    -moz-transition: background 1s ease-in-out;
    -webkit-transition: background 1s ease-in-out;
    transition: background 1s ease-in-out;
  }
  .background-video-slider .video-slide .slide-background-overlay, 
  .background-video-slider .bg-image-slide .slide-background-overlay {
    background: #111111;
    background: var(--slide-overlay-background-color, #111111);
  }
  .background-video-slider .video-slide.active .slide-background-overlay, 
  .background-video-slider .bg-image-slide.active .slide-background-overlay {
    background: linear-gradient(to top, #111111 1%, transparent 40%);
    background: linear-gradient(to top, var(--slide-overlay-background-color, #111111) 1%, transparent 40%);
  }
  .background-video-slider .video-slide.slow-load.active .slide-background-overlay {
    background: #111111;
    background: var(--slide-overlay-background-color, #111111);
  }
  .background-video-slider .slide-content-layer {
    color: #ffffff;
  }
  .background-video-slider .slide-content-layer {
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 0 70px 33px;
  }
  .background-video-slider .slide-text-content {
    font-size: 15px;
  }
  .background-video-slider .sokal-component-subheading {
    font-size: 1.25em;
  }
  .background-video-slider .sokal-component-heading {
    font-size: 3.3em;
    font-weight: bold;
  }
  .background-video-slider .sokal-component-copy {
    font-size: 1em;
    margin-bottom: 2px;
  }
  .background-video-slider .slide-buttons {
    margin-top: 20px;
  }
  .background-video-slider .sokal-btn {
    font-size: 1rem;
    font-weight: normal;
    line-height: calc(0.875rem + 2px);
    letter-spacing: 1px;
    text-align: center;
    text-decoration: none;
    min-height: 48px;
    padding: 16px 40px;
    border: 2px solid #000000;
    display: inline-block;
    position: relative;
    z-index: 0;
    box-sizing: border-box;
    transition: color ease-in-out .15s;
    margin-top: 10px;
    width: fit-content;
    background: transparent;
  }
  .background-video-slider .sokal-btn::after {
    content: "";
    display: block;
    width: 0px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    box-sizing: border-box;
    transition: width .1s ease-in-out;
  }
  .background-video-slider .sokal-btn:hover::after, 
  .background-video-slider .sokal-btn:focus::after {
    width: 100%;
    left: 0;
    transition: width ease-in-out .2s;
  }
  .background-video-slider .sokal-btn.dark-theme {
    border-color: #ffffff;
  }
  /* Primary Button */
  .background-video-slider .sokal-btn-primary.dark-theme {
    --sokal-btn-bg: #ffffff;
    --sokal-btn-color: #000000;
  }
  .background-video-slider .sokal-btn-primary {
    color: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-primary::after {
    background: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-primary:hover, 
  .background-video-slider .sokal-btn-primary:focus {
    color: var(--sokal-btn-bg);
  }
  .background-video-slider .sokal-btn-primary.dark-theme::after {
    width: 100%;
    background: #ffffff;
    background: var(--sokal-btn-background, #ffffff);
    left: unset;
    right: 0;
  }
  .background-video-slider .sokal-btn-primary.dark-theme:hover::after, 
  .background-video-slider .sokal-btn-primary.dark-theme:focus::after {
    width: 0px;
  }
  /* Secondary Button */
  .background-video-slider .sokal-btn-secondary.dark-theme {
    --sokal-btn-bg: #000000;
    --sokal-btn-color: #ffffff;
  }
  .background-video-slider .sokal-btn-secondary {
    background-color: transparent;
    color: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-secondary::after {
    background: var(--sokal-btn-color);
  }
  .background-video-slider .sokal-btn-secondary:hover, 
  .background-video-slider .sokal-btn-secondary:focus {
    color: var(--sokal-btn-bg);
  }

  /* INFINITI STYLING */
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-component-heading,
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-component-subheading {
    font-weight: lighter;
    font-family: Infiniti-Light, 'Infiniti-Light', Arial, sans-serif;
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn {
    overflow: hidden;
    border: 3px solid var(--primary-light, #ffffff); 
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn::after {
    display: none;
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-primary {
    background-color: var(--primary-light, #ffffff);
    color: var(--primary-color, #020B24);
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-primary:hover,
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-primary:focus {
    background-color: transparent;
    color: var(--primary-light, #ffffff);
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-secondary {
    color: var(--primary-light, #ffffff);
    background-color: transparent;
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-secondary:hover,
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-secondary:focus {
    color: var(--primary-color, #020B24);
    background-color: var(--primary-light, #ffffff);
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-primary,
  #backgroundVideoSlider[data-brand="Infiniti"] .sokal-btn-secondary {
    border-radius: 50px;
  }
  #backgroundVideoSlider[data-brand="Infiniti"] .component-slide-content {
    margin-top: -30px;
  }

  @media (min-width: 768px) {
    .background-video-slider .slide-content-layer {
      max-width: calc(100% - 20vw);
    }
    .background-video-slider button.prev-slide, 
    .background-video-slider button.next-slide {
      left: unset;
      transform: none;
      bottom: 60px;
    }
    .background-video-slider button.prev-slide {
      right: calc(4% + 60px);
    }
    .background-video-slider button.next-slide {
      right: 4%;
    }
    .background-video-slider button.navigate-slides svg {
      border: solid 2px #ffffff;
      border: solid 2px var(--carousel-controls-color, #ffffff);
      border-radius: 100%;
      -moz-transition: all 0.3s ease;
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
    }
    .background-video-slider .carousel-indicators {
      bottom: 10px;
    }
  }

  @media (max-width: 767px) {
    .background-video-slider .component-slide-content {
      min-height: 500px;
      height: 77vh;
    }
    .background-video-slider .slide-content-layer {
      padding: 0 30px 100px 30px;
    }
    .background-video-slider .video-slide.active .slide-background-overlay, 
    .background-video-slider .bg-image-slide.active .slide-background-overlay {
      background: linear-gradient(to top, #111111 1%, transparent 100%);
      background: linear-gradient(to top, var(--slide-overlay-background-color, #111111) 1%, transparent 100%);
    }
  }

  @media (min-width: 576px) {
    .background-video-slider .slide-buttons[data-first-btn-present="true"] .additional-btn {
      margin-left: 15px;
    }
  }

  @media (max-width: 575px) {
    .background-video-slider .sokal-btn {
      width: 100%;
    }
  }

  @media (max-width: 375px) {
    .background-video-slider .sokal-component-heading {
      font-size: 2.2em;
    }
  }
</style>